module.exports = __webpack_public_path__ + "0fa228049e4a7486decc36d48e6d39b2.fbx";